import React from 'react'
import { useDispatch } from 'react-redux';
import { MonthObj } from '../../redux/orderSlice';
import { monthNames } from '../../names';
import { getAdvertData } from '../../redux/advertSlice';

export const AdvertMonthSwitcher  = ({months}) => {

    const dispatch = useDispatch();

    const selectMonthHandler = (month) => {
        dispatch(getAdvertData({month}));
    };
    
    return (
        <div className="month-switcher">
            {months.map((m) => (
                <button
                    className={`button ${m.active ? 'active' : ''} ${m.loaded ? 'loaded' : ''}`}
                    onClick={(e) => selectMonthHandler(m.month)}
                    key={m.month}>
                    {monthNames[+m.month.split('-')[1] - 1]} {m.month.split('-')[0]}
                </button>
            ))}
        </div>
    );
}
